import React from 'react'

const PRICE_BLUR_KEY = 'eip_sample_prices_banner'

export function usePriceBlur(isFirstCard = false): boolean {
  const [isBlurred, setIsBlurred] = React.useState(
    () => localStorage.getItem(PRICE_BLUR_KEY) === 'true'
  )

  React.useEffect(() => {
    const onClear = () => setIsBlurred(false)
    window.addEventListener('eip-demographics-updated', onClear)
    return () => window.removeEventListener('eip-demographics-updated', onClear)
  }, [])

  if (isFirstCard) return false
  return isBlurred
}
